import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "enableWhatsapp" };
const _hoisted_2 = { class: "toggle-row" };
import { ref } from 'vue';
import MGToggle from './MGToggle.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnableWhatsAppWidget',
    props: {
        formatter: {}
    },
    emits: ["on", "off"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const enableWhatsapp = ref(false);
        return (_ctx, _cache) => {
            const _component_v_divider = _resolveComponent("v-divider");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[3] || (_cache[3] = _createElementVNode("p", null, "Add your mobile number to access Money Guided’s AI financial coach", -1)),
                _createVNode(_component_v_divider),
                _createElementVNode("div", _hoisted_2, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", null, "Enable AI coach via WhatsApp", -1)),
                    _createVNode(MGToggle, {
                        modelValue: enableWhatsapp.value,
                        "onUpdate:modelValue": [
                            _cache[0] || (_cache[0] = ($event) => ((enableWhatsapp).value = $event)),
                            _cache[1] || (_cache[1] = ($event) => ($event ? emit('on') : emit('off')))
                        ]
                    }, null, 8, ["modelValue"])
                ])
            ]));
        };
    }
});
